/**
 * Брейкпоинты кабинета — один источник для CSS и JS.
 *
 * Границы совпадают с медиазапросами в `stylus/styles/base/responsive.styl`:
 * расхождение значений даёт худший из багов адаптива — вёрстка уже
 * переключилась, а логика компонента ещё нет (или наоборот).
 *
 * `MOBILE_MAX` — последняя ширина, которую считаем телефоном (телефоны в
 * альбоме и планшеты в портрете начинаются с 768).
 */
export const MOBILE_MAX = 767;
export const TABLET_MAX = 1023;

/** Медиазапросы под `matchMedia` — те же границы, что и в Stylus. */
export const MEDIA_MOBILE = `(max-width: ${MOBILE_MAX}px)`;
export const MEDIA_TABLET = `(min-width: ${MOBILE_MAX + 1}px) and (max-width: ${TABLET_MAX}px)`;
export const MEDIA_DESKTOP = `(min-width: ${TABLET_MAX + 1}px)`;

/**
 * Указатель без наведения — палец. Именно `coarse`, а не ширина экрана:
 * тач-моноблок на кассе широкий, но навести курсор на нём нельзя, а значит
 * подсказки по hover и мелкие цели там так же непригодны, как на телефоне.
 */
export const MEDIA_TOUCH = "(pointer: coarse)";

/** Минимальная сторона тач-цели (WCAG 2.2 AA «Target Size (Minimum)» — 24px, наш пол выше). */
export const TOUCH_TARGET_MIN_PX = 44;
